<template>
  <div class="m_goodscollect project_detail">
    <mt-header title="My Favorite Products">
      <span slot="left" @click="()=>this.$router.back()">
        <i class="iconfont icon-left"></i>
        Return
      </span>
    </mt-header>
    <div class="m_content">
      <ul
        class="ul_list"
        v-show="zsList.list.length>0"
        v-infinite-scroll="loadMore"
        :infinite-scroll-disabled="false"
        infinite-scroll-distance="1"
        :infinite-scroll-immediate-check="false"
        >
        <li class="li_itemL" v-for="(item,index) in zsList.list" :key="index" @click="$router.push('/exhibit/details/'+item.pcid+'/'+item.ocid)">
          <div class="proname_img">
            <img :src="item.img_url" alt=""/>
          </div>
          <p class="proname_text">
            {{item.proname_en}}
          </p>
          <div class="quguan">
            <!-- 取消 -->
            <img src="https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/icon/like_1.png" @click.stop="cancel(item.pcid)" />
          </div>
        </li>
        <li class="more_loading" >
          <span v-show="zsList.list.length<zsList.listnum">
          <!-- <span > -->
            <div class="m_upload">
              <mt-spinner type="snake" color="#00ccff" :size="20" ></mt-spinner>
              <span>Loading...</span>
            </div>
          </span>
          <span v-show="zsList.list.length>=zsList.listnum" class="over">Final Page</span>
        </li>
      </ul>
      <div v-show="zsList.list.length<=0" class="zanwu">
        <div><img src="https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/icon/without.png" alt=""/></div>
        <p class="p">No data is available!</p>
      </div>
    </div>
  </div>
</template>

<script>
import { Header } from 'mint-ui';
import { reqMyProColl, reqProCollDo } from "../../../../api";
export default {
  components:{
    'mt-header':Header
  },
  data(){
    return{
      zsList:{list:[],listnum:99,pagelistnum:0,thispage:0},
    }
  },
  methods:{
    loadMore(){
      if (this.zsList.thispage*this.zsList.pagelistnum*1>=this.zsList.listnum*1) {
        return
      }
      this.init(this.zsList.thispage*1+1)
      // console.log(123);
    },
    async init(page=1){
      // const response = await reqMyProColl(page)
      const response = await reqMyProColl(page)
      if(response.code==2){
          this.zsList.list.push(...response.reslist)
          this.zsList.thispage=response.thispage
          this.zsList.listnum=response.listnum
          this.zsList.pagelistnum=response.pagelistnum
      }else{
          this.zsList={
            list:[],
            listnum:0,
            pagelistnum:0,
            thispage:0
          }
        }
      console.log(response);
    },
    async cancel(pcid){//取消收藏
      const response = await reqProCollDo(pcid)
      if (response.code==0) {
        this.zsList={
          list:[],
          listnum:0,
          pagelistnum:0,
          thispage:0
        }
        this.init()
        // this.collect=response.is_coll
        // this.success(this,'Cancel Successfully！')
      }else{
        // this.err(this,'Timeout, please try')
      }
    },
  }
}
</script>

<style scoped>
  .m_goodscollect{
    height: 100%;
    overflow: hidden;
  }
  .m_content{
    height: calc(100% - 30px);
    overflow-y: auto;
    padding: 0 10px;
  }
  .ul_list{
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }
  .li_itemL{
    position: relative;
    width: 48%;
    border-radius: 4px;
    background-color: white;
    margin-top: 14px;
    padding: 6px;
    box-shadow: 0 0 4px #8b8b8b;
  }
  .proname_img{
    width: 100%;
    height: 200px;
    /* object-fit: cover; */
  }
  .proname_img img{
    object-fit: contain;
  }
  .proname_text{
    text-align: center;
    width: 100%;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
  .quguan{
    position: absolute;
    right: 4px;
    top: 4px;
    width: 24px;
  }

/* 加载中 */
.more_loading{
  padding: 10px 0;
  line-height: 24px;
}
  /* 空 */
.zanwu{
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -70%);
  width: 240px;
  text-align: center;
}
</style>